import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useAllProjects } from "../../../hooks/DevProjectHooks";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import Sidebar from "../../../components/consolecomponents/sidebar/Sidebar";
import IsLoading from "../../../util/loader/IsLoading";
import ConsoleLocalStorage from "../../../storage/storage";
import ComingSoonModal from "../../../components/consolecomponents/modal/ComingSoonModal";

import arrowdown from "../../../Assets/arrowdown.svg";
import editrole from "../../../Assets/organization/editrole.svg";
import styles from "./Team.module.scss";
import "./styles.scss";
import searchImg from "../../../Assets/organization/search.svg";
import { Breadcrumb } from "react-bootstrap";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";
import RemoveMemberModal from "../../../components/consolecomponents/modal/RemoveMemberModal";
import InviteMemberModal from "../../../components/consolecomponents/modal/InviteMemberModal";
import AssignRoleModal from "../../../components/consolecomponents/modal/AssignRoleModal";
import { useGetAllUsers } from "../../../hooks/DevAuthHooks";
import { sliceString } from "../../../util/helpers/funcHelper";
import DEAModal from "../../../components/consolecomponents/modal/DEAModal";
import { projectStatus } from "../../../util/helpers/statusHelper";
import ResendInviteLinkModal from "../../../components/consolecomponents/modal/ResendInviteLinkModal";

const Team = () => {
  const history = useHistory();

  const [showSideBarList, setShowSidebarList] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [role, setRole] = useState("all");
  const [member, setMember] = useState({ id: 7, name: "John Doe", roles: [] });
  const [showRemoveMember, setShowRemoveMember] = useState(false);
  const [showResendInviteLinkModal, setShowResendInviteLinkModal] = useState(false);
  const [showInviteMember, setShowInviteMember] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [allUsersFiltered, setAllUsersFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [showDEA, setShowDEA] = useState(false);
  const [projectid, setProjectid] = useState(null);
  const [activeUserCount, setActiveUserCount] = useState(0);
  const [pendingUserCount, setPendingUserCount] = useState(0);
  const [linkExpiredUserCount, setLinkExpiredUserCount] = useState(0);

  const [currUser] = useState({
    role: ConsoleLocalStorage.getUser()?.roles[0].name,
    id: ConsoleLocalStorage.getUser()?.id,
  });

  let activeCount = 0;
  let pendingCount = 0;
  let expiredCount = 0;
  
  /**
   * All projects for sidebar dropdown
   */
  const {
    data: projects,
    isLoading: projectsLoading,
    isError: projectsError,
  } = useAllProjects();
  /**
   * All users
   */
  const {
    data: allUsers,
    isLoading: allUsersLoading,
    isError: allUsersError,
  } = useGetAllUsers(setAllUsersFiltered);

  const getUserTypeCount = () => {
    allUsers?.forEach((user) => {
      if(user?.isActiveUser)
        activeCount++;
      else if(!user?.isActiveUser && user?.shouldResendInviteLink < user?.expirationDays)
        pendingCount++;
      else if(!user?.isActiveUser && user?.shouldResendInviteLink > user?.expirationDays)
        expiredCount++;
    }
  )
  setActiveUserCount(activeCount)
  setPendingUserCount(pendingCount)
  setLinkExpiredUserCount(expiredCount)
}

  useEffect(() => {
    if (!allUsersLoading) {
      const tempUsers = allUsers.filter((user) => {
        return (
          (user.userType === role || role === "all") &&
          `${user.firstName} ${user.lastName} ${user.email}`
            .toLowerCase()
            ?.includes(search.toLowerCase().split(" ").join(" ").trim().replace(/\s\s+/g))
        );
      });
      setAllUsersFiltered(tempUsers);
    }
  }, [role, search]);

  useEffect(()=>{
    getUserTypeCount();
  },[allUsers])

  if (projectsLoading || allUsersLoading) {
    return <IsLoading />;
  }

  return (
    <>
      <DEAModal
        showDEA={showDEA}
        projectid={projectid}
        setShowDEA={setShowDEA}
      />
      <InviteMemberModal
        showInviteMember={showInviteMember}
        setShowInviteMember={setShowInviteMember}
      />
      <RemoveMemberModal
        showRemoveMember={showRemoveMember}
        setShowRemoveMember={setShowRemoveMember}
        member={member}
      />
      <ResendInviteLinkModal
        showResendInviteLinkModal={showResendInviteLinkModal}
        setShowResendInviteLinkModal={setShowResendInviteLinkModal}
        member={member}
      />
      <AssignRoleModal
        showAssignModal={showAssignModal}
        setShowAssignModal={setShowAssignModal}
        member={member}
      />
      <div className={styles.container}>
        <Sidebar>
          <section className="">
            <div
              onClick={() => setShowSidebarList(!showSideBarList)}
              className="sidebar_projects"
            >
              <h3 className="">
                {`All Projects (${projects?.length})`}
                <img
                  src={arrowdown}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </h3>
              {showSideBarList ? (
                <ul className="sidebar_projectlist">
                  {projects.map((project) => (
                    project.status == projectStatus.draft.status || project.status == projectStatus.rejected.status ?
                      (<li key={project.id} onClick={() => {
                        setProjectid(project.id)
                        setShowDEA(true)
                      }}>
                        <a ><span className="sidebar_list_items">
                          {project.name}
                        </span>
                        </a>
                      </li>) :
                      (
                        <li key={project.id}>
                          <Link to={`/console/${project.id}`}>
                            <span className="sidebar_list_items">
                              {project.name}
                            </span>
                          </Link>
                        </li>
                      )
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
        </Sidebar>
        <div className={`${styles.main} teams`}>
          {/**
           * Breadcrumb
           */}
          <Breadcrumb bsPrefix="breadcrumb">
            <Breadcrumb.Item href="" onClick={() => history.push("/console")}>
              <span className="breadcrumb_item">Dashboard</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <span className="breadcrumb_item active">My Team</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className={styles.body}>
            <span className={styles.heading}>
              <h3>My Team</h3>
              {currUser.role == "owner" || currUser.role == "admin" ? (
                <PrimaryButton onClick={() => setShowInviteMember(true)}>
                  Invite Member
                </PrimaryButton>
              ) : null}
            </span>
            <div className={styles.orginfopanel}>
              <span className={styles.orginfo}>
                <span>Company/Organization Name</span>
                <span>Total Members</span>
                <span style={{ fontSize: "16px" }}>
                  {ConsoleLocalStorage.getOrganization().name}
                </span>
                <span style={{ fontSize: "16px" }} className="d-flex d-align-center">{allUsers?.length}</span>
              </span>
                  <div className="d-flex d-flex-column d-align-center">
                    <span className="active-link">Active</span>
                    <span className="active-link">{activeUserCount}</span>
                  </div>
                  <div className="d-flex d-flex-column d-align-center">
                    <span className="expired-link">Link Expired</span>
                    <span className="expired-link">{linkExpiredUserCount}</span>
                  </div>
                    <div className="d-flex d-flex-column d-align-center">
                    <span className="pending-link">Pending</span>
                    <span className="pending-link">{pendingUserCount}</span>
                  </div>
              <SecondaryButton
                onClick={() => history.push("/console/organization-dashboard")}
              >
                Organization Details
              </SecondaryButton>
            </div>
            <hr style={{ color: "#e9e0e0" }} />
            <div className={styles.filterpanel}>
              <img className={styles.search} src={searchImg} alt="" />
              <input
                placeholder="Search Team Member"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className={styles.rolecontainer}>
                <span
                  style={{ textTransform: "capitalize" }}
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  {role} <img src={arrowdown} alt="" />
                </span>
                {showDropdown ? (
                  <ul>
                    <li
                      style={{ color: `${role === "all" ? "white" : ""}` }}
                      onClick={() => {
                        setRole("all");
                        setShowDropdown(false);
                      }}
                    >
                      All
                    </li>
                    <li
                      style={{ color: `${role === "admin" ? "white" : ""}` }}
                      onClick={() => {
                        setRole("admin");
                        setShowDropdown(false);
                      }}
                    >
                      Admin
                    </li>
                    <li
                      style={{
                        color: `${role === "developer" ? "white" : ""}`,
                      }}
                      onClick={() => {
                        setRole("developer");
                        setShowDropdown(false);
                      }}
                    >
                      Developer
                    </li>
                    <li
                      style={{ color: `${role === "qa" ? "white" : ""}` }}
                      onClick={() => {
                        setRole("qa");
                        setShowDropdown(false);
                      }}
                    >
                      QA
                    </li>
                  </ul>
                ) : null}
              </div>
            </div>
            {allUsersFiltered.map((user, index) => (
              <div key={index} className={`${styles.membercard} membercard`}>
                <span className="name">{`${user.firstName ? sliceString(0, 20, user.firstName, true) : "-"} ${user.lastName ? sliceString(0, 20, user.lastName, true) : ""}`}
                </span>
                <div className="d-flex d-justify-sb">
                <span>{user.email}</span>
                {<span className="pr-50">
                {user?.isActiveUser && <span className="active-link">Active</span>}
                { !user?.isActiveUser && (user?.shouldResendInviteLink<user?.expirationDays) && <span className="pending-link">Pending</span>}
                {!user?.isActiveUser && (user?.shouldResendInviteLink>user?.expirationDays) &&
                <span className="expired-link">Link Expired</span>}
                </span>}
                </div>
                <span className="roles">
                  {user.userType}
                  {(currUser.role === "owner" || currUser.role === "admin") &&
                    currUser.id !== user.id ? (
                    user?.roles[0]?.name !== 'owner' &&
                    <img style={{ marginLeft: "1rem" }} src={editrole} alt="" onClick={() => { setMember(user); setShowAssignModal(true); }} />
                  ) : null}
                </span>
                { ((currUser.role === "owner" || currUser.role === "admin") && currUser.id !== user.id && user?.roles[0]?.name!=='owner')
                &&
                 (user?.isActiveUser) ?
                  <SecondaryButton
                    onClick={() => {
                      setMember(user);
                      setShowRemoveMember(true);
                    }}
                  >
                    Remove
                  </SecondaryButton>
                 : (!user?.isActiveUser && (user?.shouldResendInviteLink > user?.expirationDays))? 
                 <SecondaryButton
                 onClick={() => {
                   setMember(user);
                   setShowResendInviteLinkModal(true);
                 }}
               >
                 Resend Invite Link
               </SecondaryButton>
                 : null
                }
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Team;
 